import { PhoneNumbersToBePortedRange } from './phoneNumbersToBePortedRange';

export class PhoneNumbersToBePorted {
  range: PhoneNumbersToBePortedRange[];
  constructor() {
    this.range = [];
  }
}



// WEBPACK FOOTER //
// ./src/models/phoneNumbersToBePorted.ts